import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebase";

// Erstelle einen Auth-Context
const AuthContext = createContext();

// Auth-Provider-Komponente
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // Überwache den Auth-Zustand
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      console.log("Benutzerzustand geändert:", user);
    });

    // Abmeldung vom Listener beim Verlassen der Komponente
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser }}>
      {children}
    </AuthContext.Provider>
  );
}

// Hook, um auf den Auth-Context zuzugreifen
export function useAuth() {
  return useContext(AuthContext);
}
